import {webRequest, webNoTokenRequest} from '../api'

// 房客拍表紀錄
export function getAvailableHouse() {
    return webRequest({
        url:'/v2/oauth/house/manage/option',
        method:'get',
    })
}




// WEBPACK FOOTER //
// ./src/apis/landlord/newPaperContract.js